function initTooltip() {
  $('[data-toggle="tooltip"]').tooltip()
}

export default initTooltip
